import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faEdit } from "@fortawesome/free-regular-svg-icons";

import { ellipsizetext } from "../../_helpers/ellipsize";
import { formatImageUrl } from "../../_helpers/route-image";



export const ItemUpdateCard = ({ item, onClick, onUpdate, onDelete }) => {
    const computeDiscount = (price, percentage) => {
        return parseInt(price) - price * parseFloat(percentage);
    }

    const { original_cost, discount } = item?.pricing;

    return (
        <div>
            <button
                className="wish-button edit-button"
                onClick={onUpdate}
            >
                <FontAwesomeIcon
                    icon={faEdit}
                />
            </button>
            <button
                className="cart-add-button delete-item"
                onClick={onDelete}
            >
                <FontAwesomeIcon
                    icon={faTrashAlt}
                />
            </button>
            <button
                className="item-container"
                key={item._id}
                onClick={onClick}
            >

                <img src={formatImageUrl(item.images[0])} alt="" className="item-img" />
                <div className="item-info">
                    <span className="item-brand">{item.brand}</span>
                    <span className="item-name">{item.designation}</span>
                    <div className="bottom-section">
                        {discount > 0 &&
                            (<strike>
                                <span className="discount-text">
                                    {original_cost} FCFA
                                </span>
                            </strike>)}

                        <span className="item-cost">
                            {original_cost - original_cost * discount} FCFA
                        </span>


                    </div>

                </div>
                <div className="more-bottom">
                    <button
                        className="more-button"
                        onClick={onClick}
                    >
                        <span className="more-text">View</span>
                    </button>
                </div>
            </button>
        </div>
    )
}